"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsRequestObsoleteError = void 0;
const tslib_1 = require("tslib");
/// <reference path="Tabs.d.ts" />
const Base64_1 = require("../../javascript/Base64");
const Utilities_1 = require("../../javascript/Utilities");
const Base_1 = require("../../model/Base");
const Instance_1 = require("../../model/Instance");
const List_1 = require("../List/List");
const SelectionContext_1 = require("../Menu/SelectionContext");
const synerisMethods_1 = require("../Menu/synerisMethods");
const TabItem_1 = require("./TabItem");
const _HeaderTemplateHtml = require("./TabItemHeaderTemplate.tmpl.htm");
const _less = require("./Tabs.tmpl.less");
var TabsPrivateDataKeys;
(function (TabsPrivateDataKeys) {
    TabsPrivateDataKeys[TabsPrivateDataKeys["Tabs"] = 0] = "Tabs";
    TabsPrivateDataKeys[TabsPrivateDataKeys["NewestRequestGUID"] = 1] = "NewestRequestGUID";
    TabsPrivateDataKeys[TabsPrivateDataKeys["TabsWidth"] = 2] = "TabsWidth";
    TabsPrivateDataKeys[TabsPrivateDataKeys["SynListLocked"] = 3] = "SynListLocked";
    TabsPrivateDataKeys[TabsPrivateDataKeys["SessionGuid"] = 4] = "SessionGuid";
    TabsPrivateDataKeys[TabsPrivateDataKeys["DisableRaiseSelect"] = 5] = "DisableRaiseSelect";
    TabsPrivateDataKeys[TabsPrivateDataKeys["IsInitialized"] = 6] = "IsInitialized";
    TabsPrivateDataKeys[TabsPrivateDataKeys["InitialTabInitializationPromise"] = 7] = "InitialTabInitializationPromise";
})(TabsPrivateDataKeys || (TabsPrivateDataKeys = {}));
class TabsRequestObsoleteError extends Error {
    constructor() {
        super("Obsolete request");
        Object.setPrototypeOf(this, TabsRequestObsoleteError.prototype);
    }
}
exports.TabsRequestObsoleteError = TabsRequestObsoleteError;
class TabsImpl {
    //#region JQuery plugin functions
    static initAsync($elem, options, forcePropertyTab = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synData = TabsImpl.getData($elem);
            if (!synData) {
                synData = $.extend({}, TabsImpl.DefaultOptions, options);
                TabsImpl.setData($elem, synData);
                $elem.addClass("synTabs");
                if (Utilities_1.synUtil.isHDScreen)
                    $elem.addClass("HDScreen");
                synData.parentContext.parentId = yield TabsImpl.fixParentIdAsync(synData.parentContext.parentId);
                yield TabsImpl.createTabStripAsync($elem, synData.parentContext, forcePropertyTab);
                TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.SessionGuid, Utilities_1.synUtil.getGUID(false));
                TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.DisableRaiseSelect, false);
                TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.IsInitialized, true);
            }
        });
    }
    static destroy($elem) {
        return $elem.each((_i, element) => {
            const $this = $(element);
            if (!TabsImpl.isInitialized($this))
                return;
            TabsImpl.destroyTabs($elem);
            if ($elem.data("kendoTabStrip"))
                $elem.data("kendoTabStrip").destroy();
            $(this).off("propertyPageValuesChanged")
                .off("propertyPageValuesReverted")
                .off("propertyPageVersionChanged")
                .off("propertyPageNeedsFullRefresh")
                .off("propertyPageIgnoredValue")
                .off("propertyPageUnsavedChangesObsolete")
                .off("tabSelected")
                .off("selectionChanged")
                .off("rowDoubleClicked")
                .off("instanceChanged")
                .off("onObjectContextMenu")
                .removeClass("synTabs")
                .removeData("synTabs");
            Object.keys(TabsPrivateDataKeys)
                .filter(k => !isNaN(parseInt(k, 10)))
                .map(k => parseInt(k, 10))
                .forEach((key) => { TabsImpl.deletePrivateData($elem, key); });
        });
    }
    static isInitialized($elem) {
        return TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.IsInitialized) === true;
    }
    static setParentAsync($elem, parentId, relIdToSelect, relIds, forcePropertyTab = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let data = TabsImpl.getData($elem);
            if (!data)
                return;
            parentId = yield TabsImpl.fixParentIdAsync(parentId);
            data.parentContext.parentId = parentId;
            data.parentContext.parentRelId = relIdToSelect;
            data.onlyTheseRelIds = relIds;
            try {
                const tabItems = yield TabsImpl.getTabItemsAsync($elem, parentId, forcePropertyTab);
                const activationPromise = new Promise((resolve) => {
                    $elem.data("kendoTabStrip")
                        .one("activate", () => {
                        resolve();
                    });
                    TabsImpl.setTabsCore($elem, tabItems);
                });
                yield activationPromise;
                const initPromise = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.InitialTabInitializationPromise);
                if (initPromise)
                    yield initPromise;
                TabsImpl.deletePrivateData($elem, TabsPrivateDataKeys.InitialTabInitializationPromise);
            }
            catch (e) {
                if (!e.TabsRequestObsoleteError)
                    throw e;
            }
        });
    }
    static refreshCurrentTab($elem) {
        return $elem.each((_i, element) => {
            const $this = $(element);
            if (!TabsImpl.getData($this))
                return;
            const tabs = TabsImpl.getPrivateData($this, TabsPrivateDataKeys.Tabs);
            const tabItem = tabs[$this.data("kendoTabStrip").select().index()];
            TabsImpl.refreshTabCoreAsync($this, tabItem);
        });
    }
    static currentTabIsPropertyTab($elem) {
        if (!TabsImpl.getData($elem))
            return false;
        const tabs = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
        return tabs[$elem.data("kendoTabStrip").select().index()].m_isPropertyTab;
    }
    static hasPropertyTab($elem) {
        if (!TabsImpl.getData($elem))
            return false;
        const tabs = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
        return tabs.some(ti => ti.m_isPropertyTab);
    }
    static getSelectedIds($elem) {
        if (!TabsImpl.getData($elem))
            return undefined;
        const tabs = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
        const currentTabItem = tabs[$elem.data("kendoTabStrip").select().index()];
        if (currentTabItem.m_isPropertyTab || !currentTabItem.m_isLoaded)
            return [];
        else
            return TabsImpl.tabItemToTabContentElem($elem, currentTabItem).synList("getSelectedIds");
    }
    static trySelectTab($elem, relId) {
        if (!TabsImpl.getData($elem))
            return false;
        const tabs = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
        const idx = tabs.findIndex(t => relId === "PropertyRel" && t.m_isPropertyTab || t.m_relId === relId);
        if (idx < 0)
            return false;
        const oldVal = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.DisableRaiseSelect);
        TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.DisableRaiseSelect, true);
        $elem.data("kendoTabStrip").select(idx);
        TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.DisableRaiseSelect, oldVal);
        return true;
    }
    static getParentId($elem) {
        if (!TabsImpl.isInitialized($elem))
            return undefined;
        const synData = TabsImpl.getData($elem);
        return synData.parentContext.parentId;
    }
    static getSelectedRelId($elem) {
        if (!TabsImpl.getData($elem))
            return undefined;
        const tabs = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
        return tabs[$elem.data("kendoTabStrip").select().index()].m_relId;
    }
    static getSelectedTabIndex($elem) {
        if (!TabsImpl.getData($elem))
            return -1;
        const $selected = $elem.data("kendoTabStrip").select();
        if (!$selected.length)
            return -1;
        return $selected.index();
    }
    static getTabCount($elem) {
        if (!TabsImpl.getData($elem))
            return undefined;
        return TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs).length;
    }
    static getPropertyPage($elem) {
        if (!TabsImpl.getData($elem))
            return $();
        const tabs = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
        const idx = tabs.findIndex(t => t.m_isPropertyTab);
        if (idx < 0)
            return $();
        return TabsImpl.tabItemToTabContentElem($elem, tabs[idx]);
    }
    static update($elem, instances) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            if (TabsImpl.isInitialized($this)) {
                $this.children(".k-content").each((_idx, tabElem) => {
                    const $tabContentElem = $(tabElem).children("div");
                    let tabItem = TabsImpl.tabContentElemToTabItem($this, $tabContentElem);
                    if (tabItem.m_isLoaded) {
                        if (tabItem.m_isPropertyTab) {
                            const propertyPageInstanceId = $tabContentElem.synPropertyPage("getInstance").id.valueAsString;
                            if (instances.filter(inst => inst.id.valueAsString === propertyPageInstanceId).length)
                                $tabContentElem.synPropertyPage("refresh");
                        }
                        else
                            $tabContentElem.synList("update", instances);
                    }
                });
            }
        });
    }
    static delete($elem, instances) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            if (TabsImpl.isInitialized($this)) {
                $this.children(".k-content").each((_idx, tabElem) => {
                    const $tabContentElem = $(tabElem).children("div");
                    let tabItem = TabsImpl.tabContentElemToTabItem($this, $tabContentElem);
                    if (tabItem.m_isLoaded) {
                        if (tabItem.m_isPropertyTab) {
                            if ($tabContentElem.data("synPropertyPage")) {
                                const propertyPageInst = $tabContentElem.synPropertyPage("getInstance");
                                if (instances.filter(inst => inst.id.valueAsString === propertyPageInst.id.valueAsString).length)
                                    $tabContentElem.synPropertyPage("destroy");
                            }
                        }
                        else {
                            $tabContentElem.synList("delete", instances);
                            TabsImpl.updateTabItemCount($this, tabItem);
                        }
                    }
                });
            }
        });
    }
    static unlinkAsync($elem, instances, parent, relation) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (parent && relation) {
                if (!TabsImpl.isInitialized($elem))
                    return;
                const synData = TabsImpl.getData($elem);
                if (synData.parentContext.parentId !== parent.id.valueAsString)
                    return;
                $elem.children(".k-content").each((_idx, tabElem) => {
                    const $tabContentElem = $(tabElem).children("div");
                    let tabItem = TabsImpl.tabContentElemToTabItem($elem, $tabContentElem);
                    if (tabItem.m_isLoaded) {
                        if (!tabItem.m_isPropertyTab) {
                            if (!tabItem.m_isAllRel && tabItem.m_relId === relation) {
                                $tabContentElem.synList("delete", instances);
                                TabsImpl.updateTabItemCount($elem, tabItem);
                            }
                        }
                    }
                });
                const allRelTabs = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs).filter(t => t.m_isAllRel && t.m_isLoaded);
                if (allRelTabs.length) {
                    const $tabContent = TabsImpl.tabItemToTabContentElem($elem, allRelTabs[0]);
                    yield $tabContent.synList("refreshAsync");
                    TabsImpl.updateTabItemCount($elem, allRelTabs[0]);
                }
            }
        });
    }
    static linkAsync($elem, instances, parent, relation) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (parent && relation) {
                if (!TabsImpl.isInitialized($elem))
                    return;
                const synData = TabsImpl.getData($elem);
                if (synData.parentContext.parentId !== parent.id.valueAsString)
                    return;
                let mapRelevantLinkings = {};
                const mapChildren = {};
                instances.forEach((inst) => {
                    mapChildren[inst.id.valueAsString] = inst;
                });
                if (relation === SelectionContext_1.SpecialRelIds.All) {
                    const instanceGraph = yield Utilities_1.synUtil.getAJAXDataAsync({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("Graph"),
                        requestData: JSON.stringify({
                            node: parent.id.valueAsString,
                            parentDepth: 0,
                            childDepth: 1,
                            fetchUncles: false
                        }),
                    });
                    for (const edge of instanceGraph.edges) {
                        if (edge.data.source === parent.id.valueAsString && mapChildren[edge.data.target]) {
                            if (!mapRelevantLinkings[edge.data.docid])
                                mapRelevantLinkings[edge.data.docid] = {};
                            mapRelevantLinkings[edge.data.docid][edge.data.target] = true;
                        }
                    }
                }
                $elem.children(".k-content").each((_idx, tabElem) => {
                    const $tabContentElem = $(tabElem).children("div");
                    let tabItem = TabsImpl.tabContentElemToTabItem($elem, $tabContentElem);
                    if (tabItem.m_isLoaded && !tabItem.m_isPropertyTab && tabItem.m_relId > 0) {
                        if (relation === SelectionContext_1.SpecialRelIds.All) {
                            if (tabItem.m_isAllRel)
                                $tabContentElem.synList("add", instances);
                            else if (mapRelevantLinkings[tabItem.m_relId.toString()]) {
                                let relevantInstances = [];
                                for (let childId in mapRelevantLinkings[tabItem.m_relId.toString()])
                                    relevantInstances.push(mapChildren[childId]);
                                $tabContentElem.synList("add", relevantInstances);
                            }
                        }
                        else if (tabItem.m_relId === relation || tabItem.m_isAllRel)
                            $tabContentElem.synList("add", instances);
                        TabsImpl.updateTabItemCount($elem, tabItem);
                    }
                });
            }
        });
    }
    static focus($elem, focused) {
        return $elem.each((_i, element) => {
            const $this = $(element);
            $this.toggleClass("unfocused", !focused);
            if (TabsImpl.getData($this)) {
                const tabs = TabsImpl.getPrivateData($this, TabsPrivateDataKeys.Tabs);
                const tabItem = tabs[$this.data("kendoTabStrip").select().index()];
                const $tabElem = TabsImpl.tabItemToTabContentElem($this, tabItem);
                if ($tabElem.synList("isInitialized"))
                    $tabElem.synList("focus", focused);
            }
        });
    }
    static isFocused($elem) {
        return !$elem.hasClass("unfocused");
    }
    static lockSynList($elem, lock) {
        return $elem.each((_i, element) => {
            const $this = $(element);
            if (!TabsImpl.getData($this))
                return;
            const tabs = TabsImpl.getPrivateData($this, TabsPrivateDataKeys.Tabs);
            const tabItem = tabs[$this.data("kendoTabStrip").select().index()];
            const $tabElem = TabsImpl.tabItemToTabContentElem($this, tabItem);
            if ($tabElem.synList("isInitialized")) {
                $tabElem.synList("lock", lock);
                TabsImpl.setPrivateData($this, TabsPrivateDataKeys.SynListLocked, lock);
            }
        });
    }
    //#endregion JQuery plugin functions
    //#region Helpers
    static createTabItemCore(parentId, relId, text, isPropertyTab, isAllRel, icon) {
        let tabItem = new TabItem_1.TabItem(parentId, relId, text);
        let $tabContent = $("<div></div>")
            .css("height", "100%")
            .attr({
            "data-parentid": parentId,
            "data-relid": relId.toString()
        });
        if (isPropertyTab) {
            tabItem.m_isPropertyTab = true;
            $tabContent.attr("data-propertytab", "true");
        }
        tabItem.m_contentHtml = $tabContent[0].outerHTML;
        if (icon)
            tabItem.m_imageUrl = Utilities_1.synUtil.getWSUrl("Icon") + "docid=" + icon.toString() + "/" + TabsImpl.getIconSize().toString();
        tabItem.m_isAllRel = isAllRel;
        return tabItem;
    }
    static fixParentIdAsync(parentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!parentId || parentId.indexOf("|") >= 0)
                return parentId;
            else {
                const inst = yield Utilities_1.synUtil.getInstanceAsync(parentId);
                return inst.id.valueAsString;
            }
        });
    }
    static getTabItemsAsync($elem, parentId, forcePropertyTab) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (typeof parentId === "undefined")
                return [];
            const synData = TabsImpl.getData($elem);
            const guid = Utilities_1.synUtil.getGUID(true);
            TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.NewestRequestGUID, guid);
            const data = yield Utilities_1.synUtil.getAJAXDataAsync({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("CategoryTabinfos") + parentId.split("|")[2],
                requestData: {
                    windowName: synData.windowName,
                    instance: parentId
                }
            });
            if (guid !== TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.NewestRequestGUID))
                throw new TabsRequestObsoleteError();
            if (typeof data.tabsWidth !== "undefined")
                TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.TabsWidth, data.tabsWidth);
            else
                TabsImpl.deletePrivateData($elem, TabsPrivateDataKeys.TabsWidth);
            let newTabs = data.tabs
                .filter((v) => {
                // Limit tabs to onlyTheseRelIds init option
                if (typeof synData.onlyTheseRelIds === "undefined")
                    return true;
                else if (typeof v.propertyRel !== "undefined")
                    return synData.onlyTheseRelIds.indexOf("PropertyRel") >= 0;
                return synData.onlyTheseRelIds.indexOf(v.relId) >= 0;
            })
                .map(v => TabsImpl.createTabItemCore(parentId, v.relId, v.text, typeof v.propertyRel !== "undefined", v.allRel === true, v.icon));
            // Ggf. PropertyTab hinzufügen
            if (forcePropertyTab && newTabs.findIndex(t => t.m_isPropertyTab) < 0) {
                newTabs.unshift(TabsImpl.createTabItemCore(parentId, 0, data.propertiesRelationName, true, false, undefined));
            }
            return newTabs;
        });
    }
    static createTabStripAsync($elem, parentContext, forcePropertyTab) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const synData = TabsImpl.getData($elem);
            const parentId = parentContext.parentId;
            try {
                let tabItems = yield TabsImpl.getTabItemsAsync($elem, parentId, forcePropertyTab);
                TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.Tabs, []);
                // This is a rather unintuitive trick:
                // When we initialize the tab control, first we create an empty tabstrip, then we assign the actual tabs
                // to the tabstrip. The kendoTabstrip then raises the activate event for the initially selected tab
                // and during an activate event, we initialize the current tab, if it has not yet been initialized.
                // However, because the createTabStripAsync() promise must await initialization, we have to wait for the 
                // initialization (list or propertypage) of the content of the intially activated tab.
                // Thus, we assign initializationPromise to the actual promise used for tab creation inside the activate
                // event (either createPropertyTabAsync() or createListControlAsync()). We then can await the promise at 
                // the end of the createTabStripAsync() function, ensuring that when createTabStripAsync() resolves, the
                // tab's content has been initialized.
                let initializationPromise;
                $elem.kendoTabStrip({
                    animation: false,
                    dataTextField: "m_headerText",
                    dataContentField: "m_contentHtml",
                    dataSource: [],
                    activate: (e) => {
                        TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs)
                            .forEach(tabItem => { tabItem.m_isSelected = false; });
                        $(e.contentElement).css("display", "flex");
                        $(e.item).closest(".k-tabstrip-wrapper").addClass("synTabStripWrapper");
                        const $tabContentElem = $(e.contentElement).children("div");
                        let tabItem = TabsImpl.tabContentElemToTabItem($elem, $tabContentElem);
                        tabItem.m_isSelected = true;
                        if (!tabItem.m_isLoaded) {
                            try {
                                if (tabItem.m_isPropertyTab)
                                    initializationPromise = TabsImpl.createPropertyTabAsync($elem, $tabContentElem);
                                else
                                    initializationPromise = TabsImpl.createListControlAsync($elem, $tabContentElem);
                                TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.InitialTabInitializationPromise, initializationPromise);
                                initializationPromise.then(() => {
                                    if (synData.allowDragDrop && !tabItem.m_isPropertyTab && tabItem.m_relId > 0)
                                        TabsImpl.addDropOverlay($elem, $tabContentElem);
                                    tabItem.m_isLoaded = true;
                                });
                            }
                            catch (e) {
                                if (!e.TabsRequestObsoleteError)
                                    throw e;
                            }
                        }
                        else if (!tabItem.m_isPropertyTab) {
                            $tabContentElem.synList("updateColLayoutAsync").then((hasChanged) => {
                                if (!hasChanged)
                                    TabsImpl.refreshTabCoreAsync($elem, tabItem).then(() => {
                                        TabsImpl.updateTabItemCount($elem, tabItem);
                                    });
                                else
                                    TabsImpl.updateTabItemCount($elem, tabItem);
                            });
                        }
                    },
                    select: (e) => {
                        if (!TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.DisableRaiseSelect)) {
                            window.setTimeout(() => {
                                const $tabHeaderElem = $elem.data("kendoTabStrip").select();
                                const tabItem = TabsImpl.tabHeaderElemToTabItem($elem, $tabHeaderElem);
                                $elem.trigger("tabSelected", [tabItem.m_parentId, tabItem.m_relId, tabItem.m_isPropertyTab]);
                            }, 1);
                        }
                    }
                });
                TabsImpl.setTabsCore($elem, tabItems);
                $elem.closest(".k-tabstrip-wrapper").addClass("synTabStripWrapper");
                if (initializationPromise)
                    yield initializationPromise;
            }
            catch (e) {
                if (!e.TabsRequestObsoleteError)
                    throw e;
            }
        });
    }
    static setTabsCore($elem, tabItems) {
        var _a;
        const synData = TabsImpl.getData($elem);
        TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.Tabs, tabItems);
        const tabWidth = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.TabsWidth);
        const tabStrip = $elem.data("kendoTabStrip");
        tabStrip.setDataSource(tabItems);
        tabStrip.tabGroup.children("li")
            .on("click", (evt) => {
            if (!TabsImpl.isFocused($elem) && evt.which === 1 /* Left mouse button */) {
                const $tabHeader = $(evt.target).closest("li");
                if ($tabHeader.hasClass("k-state-active"))
                    $elem.trigger("tabRefocusRequested");
            }
        })
            .each((idx, tabHeader) => {
            const $tabHeader = $(tabHeader);
            const $tabHeaderDesc = $tabHeader.children(".k-link");
            if (!$tabHeaderDesc.data("templateApplied")) {
                const tmpl = kendo.template(_HeaderTemplateHtml);
                $tabHeaderDesc
                    .html(tmpl(tabItems[idx]))
                    .data("templateApplied", true);
            }
            if (typeof tabWidth !== "undefined") {
                $tabHeader
                    .addClass("fixedWidth")
                    .outerWidth(tabWidth);
            }
            setTimeout(() => { this.toggleOverflowTooltip($elem, $tabHeader); });
        });
        let selIdx = 0;
        if (tabItems.length > 0) {
            const relToSelect = (_a = synData.parentContext) === null || _a === void 0 ? void 0 : _a.parentRelId;
            if (relToSelect) {
                $.each(tabItems, (idx, tabItem) => {
                    if (tabItem.m_isPropertyTab && relToSelect === "PropertyRel") {
                        selIdx = idx;
                        return false;
                    }
                    else if (tabItem.m_relId === relToSelect) {
                        selIdx = idx;
                        return false;
                    }
                });
            }
        }
        const oldVal = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.DisableRaiseSelect);
        TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.DisableRaiseSelect, true);
        $elem.data("kendoTabStrip").select(selIdx);
        TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.DisableRaiseSelect, oldVal);
    }
    static toggleOverflowTooltip($elem, $tabHeaderElem) {
        if ($tabHeaderElem.length) {
            let tabHeaderText = $tabHeaderElem.find(".tabHeaderText")[0];
            let hasOverflow = tabHeaderText.scrollWidth > tabHeaderText.clientWidth;
            if (hasOverflow) {
                let tabItem = this.tabHeaderElemToTabItem($elem, $tabHeaderElem);
                $tabHeaderElem.attr("title", tabItem.m_headerText);
            }
            else {
                $tabHeaderElem.removeAttr("title");
            }
        }
    }
    static createListControlAsync($elem, $tabContentElem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const synData = TabsImpl.getData($elem);
            const tabItem = TabsImpl.tabContentElemToTabItem($elem, $tabContentElem);
            yield $tabContentElem
                .on("selectionChanged", (evt, ids) => {
                if (!evt.isDefaultPrevented()) {
                    const tabItem = TabsImpl.tabContentElemToTabItem($elem, $tabContentElem);
                    if (tabItem.m_isSelected)
                        $elem.trigger("selectionChanged", [tabItem.m_parentId, tabItem.m_relId, ids]);
                    evt.stopPropagation();
                    evt.preventDefault();
                }
            })
                .on("itemsRefocusRequested", (evt) => {
                if (!evt.isDefaultPrevented()) {
                    $elem.trigger("listItemsRefocusRequested");
                    evt.stopPropagation();
                    evt.preventDefault();
                }
            })
                .on("rowDoubleClicked", (evt, id) => {
                $elem.trigger("rowDoubleClicked", [tabItem.m_parentId, tabItem.m_relId, id]);
                evt.stopPropagation();
            })
                .on("beforeSelectionChanged", (evt, continueObject) => {
                evt.stopPropagation();
                const listLocked = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.SynListLocked);
                continueObject.continueCallback(listLocked !== true);
            })
                .on("onObjectContextMenu", (evt, eventObjectContextMenu) => {
                evt.stopPropagation();
                $elem.trigger("onObjectContextMenu", [eventObjectContextMenu]);
            })
                .on("fetchedIds", () => {
                TabsImpl.updateTabItemCount($elem, tabItem);
            })
                .synList(TabsImpl.getListOptions(synData, tabItem));
        });
    }
    static createPropertyTabAsync($elem, $tabContentElem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const synData = TabsImpl.getData($elem);
            const tabItem = TabsImpl.tabContentElemToTabItem($elem, $tabContentElem);
            return new Promise((resolve) => {
                $tabContentElem
                    .on("valuesChanged", (_e, _c, changedInstance) => {
                    $elem.trigger("propertyPageValuesChanged", [tabItem.m_parentId, tabItem.m_relId, changedInstance]);
                })
                    .on("valuesReverted", () => {
                    $elem.trigger("propertyPageValuesReverted");
                })
                    .on("versionChanged", (_e, options) => {
                    $elem.trigger("propertyPageVersionChanged", options);
                })
                    .on("needsFullRefresh", (_e, typeId) => {
                    $elem.trigger("propertyPageNeedsFullRefresh", [typeId]);
                })
                    .on("ignoredValue", (_e, presentedField) => {
                    $elem.trigger("propertyPageIgnoredValue", [presentedField]);
                })
                    .on("unsavedChangesObsolete", (_e, eTag) => {
                    $elem.trigger("propertyPageUnsavedChangesObsolete", [eTag]);
                })
                    .synPropertyPage({
                    layout: synData.renderMode === "desktop" ? "absolute" : "table",
                    renderMode: synData.renderMode,
                    checkForUnsavedChanges: synData.propertyPageCheckForUnsavedChanges
                });
                $tabContentElem
                    .one("instanceChanged", (_e, instance) => {
                    $tabContentElem.attr("data-instanceid", instance.id.valueAsString);
                    $elem.trigger("instanceChanged", instance);
                    resolve();
                })
                    .synPropertyPage("setInstance", { id: tabItem.m_parentId, mode: synData.propertyPageMode });
            });
        });
    }
    static refreshTabCoreAsync($elem, tabItem) {
        return new Promise((resolve) => {
            if (tabItem.m_isPropertyTab)
                TabsImpl.tabItemToTabContentElem($elem, tabItem)
                    .one("instanceChanged", () => { resolve(); })
                    .synPropertyPage("refresh");
            else {
                const $tabElem = TabsImpl.tabItemToTabContentElem($elem, tabItem);
                $tabElem.synList("refreshAsync")
                    .then(() => {
                    TabsImpl.updateTabItemCount($elem, tabItem);
                    resolve();
                });
            }
        });
    }
    static addDropOverlay($elem, $tabContentElem) {
        const tabItem = TabsImpl.tabContentElemToTabItem($elem, $tabContentElem);
        const synData = TabsImpl.getData($elem);
        // AA8308 File Drag&Drop
        const enableDropOverlay = function ($tabElem, enable) {
            if (enable)
                $tabElem.find($("div.dropOverlay")).show();
            else
                $tabElem.find($("div.dropOverlay")).hide();
        };
        const $dropOverlay = $("<div></div>")
            .addClass("dropOverlay")
            .css("display", "none")
            .prependTo($tabContentElem);
        $dropOverlay.append($("<div style='display: inline-block'></div>")
            .text(Utilities_1.synUtil.Strings.getValue("dropfileshere", "Drop file(s) here")));
        if ($tabContentElem.length) {
            $tabContentElem[0].ondragenter = (_e) => {
                if (tabItem.m_relId > 0 && !tabItem.m_isPropertyTab)
                    enableDropOverlay($elem, true);
            };
            $tabContentElem[0].ondragleave = (_e) => {
                enableDropOverlay($elem, false);
            };
            $tabContentElem[0].ondragover = (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (e.dataTransfer)
                    e.dataTransfer.dropEffect = "copy";
                if (tabItem.m_relId > 0 && !tabItem.m_isPropertyTab)
                    enableDropOverlay($elem, true);
            };
            $tabContentElem[0].ondrop = (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                e.preventDefault();
                e.stopPropagation();
                if (tabItem.m_relId > 0 && !tabItem.m_isPropertyTab) {
                    enableDropOverlay($elem, false);
                    let files = (e.dataTransfer) ? e.dataTransfer.files : e.files;
                    let filesToAppend = [];
                    let mailsToAppend = [];
                    let mailFileTypes = [];
                    let mailGuids = [];
                    let filesJSON = [];
                    let formData = new FormData();
                    let str = "";
                    let numValidFiles = 0;
                    let numValidMails = 0;
                    for (let i = 0; i < files.length; ++i) {
                        let filename = Utilities_1.synUtil.getFileName(files[i].name);
                        let splitFileName = filename.split(".");
                        let fileType = splitFileName[splitFileName.length - 1];
                        if (splitFileName.length === 1)
                            Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("webtoolktipuploadnofiletype"));
                        else if (files[i].size === 0)
                            Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("ERROR_37|1008"));
                        else if (files[i].size >= 2147483648)
                            Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("ERROR_200024|5"));
                        else if (fileType === "lnk")
                            Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("webtoolkituploadnolinks"));
                        else if (fileType === "msg" || fileType === "eml") {
                            mailsToAppend.push(files[i]);
                            mailFileTypes.push(fileType);
                            mailGuids.push(Utilities_1.synUtil.getGUID());
                            ++numValidMails;
                        }
                        else {
                            str += filename;
                            if (i < files.length - 1)
                                str += "|";
                            filesToAppend.push(files[i]);
                            filesJSON.push({
                                name: filename,
                                size: files[i].size
                            });
                            ++numValidFiles;
                        }
                    }
                    if (numValidMails > 0)
                        $.when(TabsImpl.uploadMailsAsync(mailsToAppend, mailFileTypes, mailGuids)).done(function () {
                            $(".staticButtons .mails").synMail("refresh", mailGuids, tabItem.m_parentId, tabItem.m_relId);
                        });
                    if (numValidFiles > 0) {
                        // check if content upload is allowed here
                        const uploadDisabled = Utilities_1.synUtil.Configs.getValue("webtoolkitdisablefileuploadonnew", undefined, parseInt(tabItem.m_parentId.split("|")[2], 10)) === "Y";
                        // create new document without newDoc-mask
                        let directNewDocCreation = Utilities_1.synUtil.Configs.getValue("draganddropautocreatetypeid." + tabItem.m_relId.toString() + "." + tabItem.m_parentId.split("|")[2]);
                        if (directNewDocCreation === "")
                            directNewDocCreation = Utilities_1.synUtil.Configs.getValue("draganddropautocreatetypeid.." + tabItem.m_parentId.split("|")[2]);
                        let template;
                        const inst = yield Utilities_1.synUtil.getInstanceAsync(tabItem.m_parentId);
                        // check if creation of typeID is allowed here
                        if (inst["items"]["cgdocument.ceallowedchildcats"].valueAsArray.length > 0 && directNewDocCreation !== "")
                            if (!inst["items"]["cgdocument.ceallowedchildcats"].valueAsArray.includes(directNewDocCreation)) {
                                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("contentNotAllowed"));
                                return;
                            }
                        if (directNewDocCreation !== "")
                            template = yield Utilities_1.synUtil.getTemplateAsync(parseInt(directNewDocCreation, 10), Base_1.PropertyPageMode.New);
                        // check if upload is allowed here and template exists
                        if (directNewDocCreation !== "" && (uploadDisabled || template == undefined)) {
                            Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("contentNotAllowed"));
                            return;
                        }
                        const sessionGuid = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.SessionGuid);
                        if (sessionGuid)
                            formData.append("sessionGUID", sessionGuid);
                        formData.append("base64FileNames", Base64_1.Base64.encode(str));
                        for (let file of filesToAppend)
                            formData.append("files", file);
                        Utilities_1.synUtil.beginAjaxProgress();
                        Utilities_1.synUtil.getAJAXData({
                            url: Utilities_1.synUtil.getWSUrl("ContentUpload"),
                            requestData: formData,
                            method: "POST",
                            contentType: false,
                            processData: false,
                            done: (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                Utilities_1.synUtil.endAjaxProgress();
                                filesJSON.forEach((file) => {
                                    file["fileGuid"] = data[file.name + "_" + sessionGuid];
                                    file["extension"] = file.name.split(".").pop();
                                    file["size"] = file.size;
                                });
                                sessionStorage.setItem("TabsFileDragAndDrop", JSON.stringify(filesJSON));
                                if (directNewDocCreation !== "") {
                                    for (let file in filesJSON) {
                                        template.items["cgdocument.doclabel"].valueAsString = filesJSON[file]["name"];
                                        Utilities_1.synUtil.getAJAXData({
                                            method: "PUT",
                                            url: Utilities_1.synUtil.getWSUrl("InstanceCreate"),
                                            requestData: {
                                                instance: JSON.stringify(template.toJSON()),
                                                parentId: tabItem.m_parentId,
                                                parentRelId: tabItem.m_relId,
                                                fileGUIDs: filesJSON[file]
                                            },
                                            done() {
                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                                });
                                            },
                                            fail(jqXHR, textStatus, errorThrown, url) {
                                                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                            }
                                        });
                                        const $tabElem = TabsImpl.tabItemToTabContentElem($elem, tabItem);
                                        $tabElem.synList("refreshAsync")
                                            .then(() => {
                                            TabsImpl.updateTabItemCount($elem, tabItem);
                                        });
                                    }
                                }
                                else if (filesJSON.length === 1)
                                    synerisMethods_1.synerisMethods.cefunc["111"].impl([], tabItem.m_parentId, tabItem.m_relId, true);
                                else
                                    synerisMethods_1.synerisMethods.guimethods.multidocnew.impl([], tabItem.m_parentId, tabItem.m_relId);
                            }),
                            cleanUp: () => {
                                Utilities_1.synUtil.endAjaxProgress();
                            }
                        });
                    }
                }
            });
        }
    }
    static getListOptions(synData, tabItem) {
        return {
            dataItemGenerator: (ctx) => {
                return new Promise((resolve) => {
                    Utilities_1.synUtil.getAJAXData({
                        url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + tabItem.m_parentId + "/" + tabItem.m_relId.toString(),
                        done: (resultsId, _textStatus, _jqXHR, handlerKey) => {
                            let headers = {};
                            if (handlerKey)
                                headers["X-WS-Affinity"] = handlerKey;
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                                headers,
                                requestData: {
                                    fieldNames: JSON.stringify(ctx.columnNames),
                                    oneShot: (synData.pageSize > 0 || synData.sortableCols ? "false" : "true"),
                                },
                                done: (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    const fixed = yield Instance_1.Instance.fromJSONArray(data.data);
                                    resolve(List_1.instancesToListDataItems(fixed));
                                })
                            });
                        }
                    });
                });
            },
            columnOptions: {
                parentId: tabItem.m_parentId,
                relId: tabItem.m_relId
            },
            raiseBeforeSelectionChanged: true,
            reorderableCols: synData.reorderableCols,
            resizableCols: synData.resizableCols,
            sortableCols: synData.sortableCols,
            useAlternateRowStyle: synData.useAlternateRowStyleForLists
        };
    }
    static updateTabItemCount($elem, tabItem) {
        if (!tabItem.m_isLoaded || tabItem.m_isPropertyTab)
            return;
        if (tabItem.m_isSelected) {
            window.setTimeout(() => {
                const $tabHeaderElem = TabsImpl.tabItemToTabHeaderElem($elem, tabItem);
                const $tabContentElem = TabsImpl.tabItemToTabContentElem($elem, tabItem);
                const itemCount = $tabContentElem.synList("getItemCount");
                const $headerTextWrapper = $tabHeaderElem.find(".k-link").css("width", "");
                $tabHeaderElem.find(".tabCounter").text(kendo.format("({0})", itemCount));
                const tabWidth = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.TabsWidth);
                if (typeof tabWidth === "undefined") {
                    const headerTextWrapperInnerWidth = $headerTextWrapper.innerWidth();
                    if (headerTextWrapperInnerWidth > 0)
                        $headerTextWrapper.innerWidth(Math.ceil(headerTextWrapperInnerWidth));
                }
                this.toggleOverflowTooltip($elem, $tabHeaderElem);
            }, 1);
        }
    }
    static tabHeaderElemToTabItem($elem, $tabHeaderElem) {
        let tabIdx = $tabHeaderElem.index();
        const tabItems = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
        return tabItems[tabIdx];
    }
    static tabContentElemToTabItem($elem, $tabContentElem) {
        let tabIdx = $tabContentElem.closest(".k-content").index(".k-content");
        const tabItems = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
        return tabItems[tabIdx];
    }
    static tabItemToTabHeaderElem($elem, tabItem) {
        const tabs = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
        const idx = tabs.findIndex(t => t.m_relId == tabItem.m_relId && t.m_parentId === tabItem.m_parentId);
        return $($elem.data("kendoTabStrip").items()[idx]);
    }
    static tabItemToTabContentElem($elem, tabItem) {
        let selector = "[data-parentid='" + tabItem.m_parentId + "'][data-relid='" + tabItem.m_relId + "']";
        if (tabItem.m_isPropertyTab)
            selector += "[data-propertytab='true']";
        return $elem.find(selector);
    }
    static getTabContentItem($elem, parentId, relId) {
        return $elem.find("[data-parentid='" + parentId + "'][data-relid='" + relId.toString() + "']");
    }
    static setData($elem, data) {
        $elem.data("synTabs", data);
    }
    static getData($elem) {
        return $elem.data("synTabs");
    }
    static setPrivateData($elem, key, data) {
        $elem.data(TabsPrivateDataKeys[key], data);
    }
    static getPrivateData($elem, key) {
        return $elem.data(TabsPrivateDataKeys[key]);
    }
    static deletePrivateData($elem, key) {
        $elem.removeData(TabsPrivateDataKeys[key]);
    }
    static destroyTabs($elem) {
        if ($elem.data("kendoTabStrip")) {
            const tabs = TabsImpl.getPrivateData($elem, TabsPrivateDataKeys.Tabs);
            for (let i = 0; i < tabs.length; ++i) {
                const $tabContent = TabsImpl.getTabContentItem($elem, tabs[i].m_parentId, tabs[i].m_relId);
                if (tabs[i].m_isPropertyTab && typeof $tabContent.data("synPropertyPage") !== "undefined")
                    $tabContent.synPropertyPage("destroy");
                else if (typeof $tabContent.data("synList") !== "undefined")
                    $tabContent.synList("destroy");
            }
            $elem.data("kendoTabStrip").remove(".k-item");
            TabsImpl.setPrivateData($elem, TabsPrivateDataKeys.Tabs, []);
        }
    }
    static uploadMailsAsync(files, mailFileTypes, mailGuids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            for (let file in files) {
                let GUID = mailGuids[file];
                let fileName = "syn_" + GUID + "." + mailFileTypes[file];
                let containerId = GUID;
                let importBehavior = Utilities_1.synUtil.Configs.getValue("webtoolkitmailimportdefault", "import");
                let contentType = "application/vnd.ms-outlook";
                if (mailFileTypes[file] === "eml")
                    contentType = "message/rfc822";
                let formData = new FormData();
                formData.append("X-FileId", "mailmessage");
                formData.append("file", files[file]);
                let boundary = Utilities_1.synUtil.getGUID(true);
                let req = new Request("WSProxy.axd?cache=FileCache/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "multipart/form-data; boundary=" + boundary,
                        "X-ContainerId": containerId,
                        "X-Retention": "18000"
                    },
                    body: new Blob([
                        "--" + boundary + "\r\n",
                        "Content-Disposition: inline; filename=" + fileName + "\r\n",
                        "X-FileId: mailmessage\r\n\r\n",
                        files[file],
                        "\r\n--" + boundary + "--"
                    ])
                });
                Utilities_1.synUtil.beginAjaxProgress();
                try {
                    yield fetch(req);
                    yield TabsImpl.resolveMailAsync(contentType, containerId);
                    if (importBehavior === "none")
                        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("mailsimported"));
                }
                finally {
                    Utilities_1.synUtil.endAjaxProgress();
                }
            }
        });
    }
    static resolveMailAsync(contentType, containerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield Utilities_1.synUtil.getAJAXDataAsync({
                url: Utilities_1.synUtil.getWSUrl("IntegrationWriteMailsToCache"),
                method: "POST",
                contentType,
                requestData: JSON.stringify({
                    CacheIds: containerId
                })
            });
        });
    }
    static getIconSize() {
        if (Utilities_1.synUtil.isHDScreen)
            return 32;
        return 16;
    }
}
/**
 * Contains all default values for option parameters not passed by the caller
 */
TabsImpl.DefaultOptions = {
    resizableCols: true,
    reorderableCols: true,
    sortableCols: true,
    pageSize: 0,
    renderMode: "desktop",
    propertyPageMode: Base_1.PropertyPageMode.View,
    propertyPageCheckForUnsavedChanges: false,
    parentContext: undefined,
    useAlternateRowStyleForLists: true,
    allowDragDrop: false
};
(($) => {
    $.fn.synTabs = function () {
        if (!arguments.length || typeof arguments[0] === "object")
            // eslint-disable-next-line no-null/no-null
            return TabsImpl.initAsync.apply(null, [this].concat(Array.prototype.slice.call(arguments)));
        else if (typeof arguments[0] === "string" && TabsImpl[arguments[0]])
            // eslint-disable-next-line no-null/no-null
            return TabsImpl[arguments[0]].apply(null, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else
            $.error("Method " + arguments[0] + " does not exist on jQuery.synTabs");
    };
})(jQuery);
